import React, { useState } from 'react';
import styleable from 'react-styleable';
import { t } from '@lingui/macro';
import { Button } from '@3plearning/react-components';
import UpArrowIcon from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_up_solid.svg';
import { useLocalisation } from '@3plearning/lingui-cdn';
import { useSelector } from 'react-redux';
import css from './assignment-result.scss';

import { ASSIGNMENT_RESULT_TYPES } from './assignment-result-reducer';

import ContextModal from '../context-modal/context-modal';
import AttemptItem from './components/attempt-item/attempt-item';

const AssignmentResult = () => {
    const { i18n } = useLocalisation();
    const assignmentResultType = useSelector(
        (state) => state.assignmentResultType
    );
    const [showContextModal, setShowContextModal] = useState(false);
    const { HIGHEST, TEACHER_ASSIGNED, VOLUNTARY } = ASSIGNMENT_RESULT_TYPES;

    const getButtonText = () => {
        let text = '';

        switch (assignmentResultType) {
            case HIGHEST:
                text = i18n._(
                    t`Assignment Item - showing all highest attempts`
                );
                break;
            case TEACHER_ASSIGNED:
                text = i18n._(
                    t`Assignment Item - showing teacher assigned attempts`
                );
                break;
            case VOLUNTARY:
                text = i18n._(t`Assignment Item - showing voluntary attempts`);
                break;
            default:
                return '';
        }

        return (
            <div className={css.text} key="assignment-button" title={text}>
                {text}
            </div>
        );
    };

    return (
        <div className={css['assignment-results-container']}>
            <div className={css['assignment-results-wrapper']}>
                <Button
                    text={getButtonText()}
                    className={css['assignment-button']}
                    onClick={() => setShowContextModal(!showContextModal)}
                    icon={UpArrowIcon}
                    alignIcon={'RIGHT'}
                />
                <div className={css.border} />
                <ContextModal
                    className={css['assignment-results-context-modal']}
                    show={showContextModal}
                    onClickOutsideHandler={() => setShowContextModal(false)}
                >
                    <div className={css['assigned-attempts-container']}>
                        <div className={css['assigned-attempts-wrapper']}>
                            <span className={css['header-text']}>
                                {i18n._(
                                    t`Assignment Item - FilterByStudentAttempts`
                                )}
                            </span>
                            <AttemptItem type={HIGHEST} />
                            <AttemptItem type={TEACHER_ASSIGNED} />
                            <AttemptItem type={VOLUNTARY} />
                        </div>
                    </div>
                </ContextModal>
            </div>
        </div>
    );
};

export default styleable(css)(AssignmentResult);



// WEBPACK FOOTER //
// ./components/assignment-result/assignment-result.js